var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface2639079"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.644531 19.65625 L 2.644531 0.324219 L 12.925781 0.324219 L 17.335938 4.738281 L 17.335938 19.65625 Z M 2.644531 19.65625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.058824%,54.509804%,61.176471%)",
      fillOpacity: 1
    },
    d: "M 12.765625 0.710938 L 16.949219 4.898438 L 16.949219 19.269531 L 3.03125 19.269531 L 3.03125 0.710938 L 12.765625 0.710938 M 13.085938 -0.0625 L 2.257812 -0.0625 L 2.257812 20.042969 L 17.722656 20.042969 L 17.722656 4.578125 Z M 13.085938 -0.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.699219 4.964844 L 12.699219 0.324219 L 12.925781 0.324219 L 17.335938 4.738281 L 17.335938 4.964844 Z M 12.699219 4.964844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.058824%,54.509804%,61.176471%)",
      fillOpacity: 1
    },
    d: "M 13.085938 1.03125 L 16.628906 4.578125 L 13.085938 4.578125 L 13.085938 1.03125 M 13.085938 -0.0625 L 12.3125 -0.0625 L 12.3125 5.351562 L 17.722656 5.351562 L 17.722656 4.578125 Z M 13.085938 -0.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,67.843137%,94.117647%)",
      fillOpacity: 1
    },
    d: "M 11.910156 9.921875 L 9.992188 11.703125 L 12.632812 14.628906 L 14.628906 14.628906 L 14.628906 12.453125 Z M 11.910156 9.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(70.980392%,87.058824%,100%)",
      fillOpacity: 1
    },
    d: "M 13.472656 6.898438 C 12.828125 6.898438 12.3125 7.417969 12.3125 8.058594 C 12.3125 8.699219 12.828125 9.21875 13.472656 9.21875 C 14.113281 9.21875 14.628906 8.699219 14.628906 8.058594 C 14.628906 7.417969 14.113281 6.898438 13.472656 6.898438 Z M 13.203125 14.628906 L 5.351562 14.628906 L 5.351562 12.3125 L 8.445312 9.21875 Z M 13.203125 14.628906 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.ad3c3e55.svg";
export { ForwardRef as ReactComponent };